import { Reset } from 'styled-reset';
import { GlobalTheme } from '../config/GlobalTheme';
import { Router } from '@reach/router';
import { ScreenRoute } from './ScreenRoute';
import { ProblemRoute } from './ProblemRoute';
import { problems } from '../data/problems';

export const App = () => (
  <>
    <GlobalTheme />
    <Reset />
    <Router>
      <ScreenRoute default path="/" file="about.md" filter="none" />
      <ScreenRoute path="/greedy" file="greedy.md" filter="greedy" />
      <ScreenRoute
        path="/backtracking"
        file="backtracking.md"
        filter="backtracking"
      />
      <ScreenRoute path="/dynamic" file="dynamic.md" filter="dynamic" />
      <ScreenRoute path="/impera" file="impera.md" filter="impera" />
      <ScreenRoute path="/problems" file="problems.md" filter="*" />

      {problems.map((problem) => (
        <ProblemRoute path={`/problems/${problem.name}`} file={problem.name} />
      ))}
    </Router>
  </>
);
